import { LoadingSkeleton } from '@eventbrite/loading-skeleton';
import React from 'react';
import { useClientStatsigEnrollment } from '../../../../context/experiments';
import { GetEnrollmentStatus } from '../../../../hooks';
import { IconOrImageCategoryBrowseExperiment } from '../../../../types';
import { IconCategoryBrowse } from '../IconCategoryBrowse';
import { ImageCategoryBrowse } from '../ImageCategoryBrowse';
import './CategoryBrowseExperiment.scss';

export const CategoryBrowseExperiment: React.FunctionComponent<{
    isMobile: boolean;
}> = ({ isMobile }) => {
    const iconOrImageCategoryBrowseExperiment = useClientStatsigEnrollment({
        name: IconOrImageCategoryBrowseExperiment.name,
        paramName: IconOrImageCategoryBrowseExperiment.paramName,
        defaultValue: IconOrImageCategoryBrowseExperiment.values.control,
    });

    const iconOrImageCategoryBrowseVariant =
        iconOrImageCategoryBrowseExperiment.status ===
        GetEnrollmentStatus.SUCCESS
            ? iconOrImageCategoryBrowseExperiment.variant
            : GetEnrollmentStatus.LOADING;

    if (iconOrImageCategoryBrowseVariant == GetEnrollmentStatus.LOADING) {
        return (
            <LoadingSkeleton
                height={isMobile ? '142px' : '223px'}
                className="shimmer-effect loadingHeight"
            />
        );
    }

    return (
        <div className="showComponent">
            {iconOrImageCategoryBrowseVariant ==
                IconOrImageCategoryBrowseExperiment.values.control && (
                <ImageCategoryBrowse />
            )}
            {iconOrImageCategoryBrowseVariant ==
                IconOrImageCategoryBrowseExperiment.values.test && (
                <IconCategoryBrowse />
            )}
        </div>
    );
};
